import { useLocation } from 'react-router-dom';
import type { MemberScreenId } from './navigation';
import { routeFromNavigation, routeFromState, routeToScreen, serverResolvedRoute } from './routes';

/**
 * Resolve the active member tab for the current location, shared by the shell
 * (active nav) and the content area (which screen to render). Client-side
 * navigations stash the canonical route on history state; deep links and
 * refreshes fall back to matching the SEF path against the nav map, then to the
 * server's resolved route.
 */
export function useResolvedRoute(): MemberScreenId {
  const location = useLocation();

  const route =
    routeFromState(location.state) ||
    routeFromNavigation(location.pathname, location.search) ||
    serverResolvedRoute();

  return routeToScreen(route);
}
